import React from 'react';
import DimensionByYearReport from './DimensionByYearReport';
import { SOURCE_LABEL } from '../../orders/constants';

export default function ChannelByYear() {
  return (
    <DimensionByYearReport
      title="Sales by channel"
      dimension="byChannel"
      rowLabel="Channel"
      rowLabels={SOURCE_LABEL}
    />
  );
}
